import { format, startOfMonth } from 'date-fns';

const DATE_FORMAT = 'yyyy-MM-dd';

export const getCurrentDate = () => format(new Date(), DATE_FORMAT);

export const getFirstDateOfMonth = () =>
  format(startOfMonth(new Date()), DATE_FORMAT);
